import {
  GET_ARCHIVED_USER,
  GET_DASHBOARD_ACTIVITY,
  GET_DASHBOARD_APPROACHING_DEAD,
  GET_DASHBOARD_MEMBER_SUMMARY,
  GET_DASHBOARD_MISSED_DEAD,
  GET_DASHBOARD_PROJECT_LIST,
  GET_DASHBOARD_SCREENSHOT,
  GET_DASHBOARD_SUMMARY,
  GET_DASHBOARD_TASK_LIST,
  GET_DASHBOARD_TASK_SUMMARY,
  GET_DASHBOARD_TEAM_LIST,
  GET_DASHBOARD_TODAYS_ACTIVITY,
  GET_DASHBOARD_TOP_MEMBERS,
  GET_DOMAIN_USER,
  GET_HOLIDAY__LIST,
  GET_HOLIDAY_BY_ID,
  GET_LEAVE_BALANCE,
  GET_LEAVE_LIST,
  GET_LEAVE_POLICY,
  GET_LEAVE_POLICY_BY_ID,
  GET_MEMBER_BY_ID,
  GET_MEMBER_INVITE_LINK,
  GET_MEMBER_LIST,
  GET_MONITORING_DAILY_ACTIVITY,
  GET_INTERNET_SPEED_LOCATION,
  GET_INTERNET_SPEED_LOCATION_SUMMARY,
  GET_MONITORING_MEMBER,
  GET_MONITORING_PROJECT,
  GET_MONITORING_SCREENSHOTS,
  GET_ONBOARD_MEMBERS_LIST,
  GET_ONBOARD_STATUS,
  GET_ONBOARD_TEAMS_LIST,
  GET_ONBOARD_USER,
  GET_PROJECT_BY_ID,
  GET_PROJECT_TASK_BY_ID,
  GET_PROJECT_TASK_LIST,
  GET_PROJECTS,
  GET_REALTIME_LIST,
  GET_REALTIME_MEMBER_LIST,
  GET_REALTIME_PROJECT_LIST,
  GET_REPORTS_ACTIVITY_LEVEL,
  GET_REPORTS_ATTENDANCE,
  GET_REPORTS_ATTENDANCE_MINUTE_WISE,
  GET_REPORTS_TRACKED_HOURS,
  GET_REPORTS_TRACKED_HOURS_MINUTE_WISE,
  GET_SCREENSHOT_DETAILS,
  GET_TEAM_LIST,
  GET_TIMEEDITOR_LIST,
  GET_TIMESHEET,
  GET_TIMESHEET_MEMBER,
  GET_TIMESHEET_PROJECT_LIST,
  GET_TIMESHEET_TASK_LIST,
  GET_TITLE_LIST,
  USER_LOGIN_DETAILS,
  GET_ADMIN_CHATS,
  GET_IMAGE_DATA,
  GET_DOMAIN_USER_BY_ID,
  GET_SUPERADMIN_DASHBOARD_DATA,
  GET_SCHEDULE_REPORT_LIST,
  GET_TIMEZONE_LIST,
  GET_SCHEDULE_REPORT_BYID,
  GET_SHARE_REPORT,
  GET_SHARE_REPORT_PUBLIC,
  GET_WORKSPACE,
  GET_EMPLOYEE_DOMAIN,
  GET_EMPLOYEE_DASHBOARD,
  GET_CHAT_EMPLOYEE_LIST,
  GET_EMPLOYEE_WORKSPACE,
  GET_EMPLOYEE_TIMESHEET_MEMBER,
  GET_EMPLOYEE_TIMESHEET_PROJECT,
  GET_EMPLOYEE_TIMESHEET_PROJECT_TASK,
  GET_EMPLOYEE_TIMESHEET,
  GET_TIME_REQUEST,
  GET_TIMEZONES,
  GET_DOMAIN_DETAILS,
  GET_EMPLOYEE_APP_USAGE,
  GET_EMPLOYEE_PAST_ACTIVITIES,
  GET_EMPLOYEE_PROJECTS,
  GET_EMPLOYEE_PROJECT_TASK_LIST,
  GET_REPORTS_ATTENDANCE_IDLE_MINUTE_WISE,
  GET_REPORTS_TRACKED_HOURS_IDLE_MINUTE_WISE,
} from './type';

// Login
const initialState = {
  LoginData: {},
  teams: [],
  title: [],
  member: [],
  memberByID: [],
  projects: [],
  projectByID: [],
  inviteLink: [],
  dashboardTeamList: [],
  dashboardSummary: [],
  dashboardTodayActivity: [],
  dashboardActivity: [],
  dashboardProjectList: [],
  dashboardTaskList: [],
  dashboardTaskSummary: [],
  dashboardMemberSummary: [],
  dashboardScreenShot: [],
  dashboardTopMembers: [],
  dashboardmissedDeadline: [],
  projectTask: [],
  projectTaskById: [],
  reportsTrackedHours: [],
  reportsTrackedHoursMinuteWise: [],
  reportsTrackedHoursIdleMinuteWise: [],
  reportsActivityLevel: [],
  reportsAttendance: [],
  reportsAttendanceMinuteWise: [],
  reportsAttendanceIdleMinuteWise: [],
  monitoringMember: [],
  monitoringProject: [],
  monitoringDailyActivity: [],
  monitoringScreenshot: [],
  realTime: [],
  holiday: [],
  leave: [],
  leavePolicy: [],
  leavePolicyByID: [],
  leaveBalance: [],
  timesheetMember: [],
  timesheet: [],
  timesheetTask: [],
  timesheetProject: [],
  timeEditor: [],
  realTimeMember: [],
  realTimePoject: [],
  domainUser: [],
  adminDashboardData: {},
  timezoneList: [],
  domainDetails: {},
  internetSpeedLocation: [],
  internetSpeedLocationSummary: {},
  employeePastActivities: {},
  employeeAppUsage: {},
  employeeProjects: {},
  employeeProjectTasks: {},
};

const mainReducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_LOGIN_DETAILS:
      return {
        ...state,
        LoginData: action.payload,
      };
    case GET_TEAM_LIST:
      return {
        ...state,
        teams: action.payload,
      };
    case GET_TITLE_LIST:
      return {
        ...state,
        title: action.payload,
      };
    case GET_MEMBER_LIST:
      return {
        ...state,
        member: action.payload,
      };

    case GET_MEMBER_BY_ID:
      return {
        ...state,
        memberByID: action.payload,
      };
    case GET_PROJECTS:
      return {
        ...state,
        projects: action.payload,
      };
    case GET_EMPLOYEE_PROJECTS:
      return {
        ...state,
        employeeProjects: action.payload,
      };
    case GET_PROJECT_BY_ID:
      return {
        ...state,
        projectByID: action.payload,
      };
    case GET_MEMBER_INVITE_LINK:
      return {
        ...state,
        inviteLink: action.payload,
      };
    case GET_DASHBOARD_TEAM_LIST:
      return {
        ...state,
        dashboardTeamList: action.payload,
      };
    case GET_DASHBOARD_SUMMARY:
      return {
        ...state,
        dashboardSummary: action.payload,
      };
    case GET_DASHBOARD_TODAYS_ACTIVITY:
      return {
        ...state,
        dashboardTodayActivity: action.payload,
      };
    case GET_DASHBOARD_ACTIVITY:
      return {
        ...state,
        dashboardActivity: action.payload,
      };
    case GET_DASHBOARD_PROJECT_LIST:
      return {
        ...state,
        dashboardProjectList: action.payload,
      };
    case GET_DASHBOARD_TASK_LIST:
      return {
        ...state,
        dashboardTaskList: action.payload,
      };
    case GET_DASHBOARD_TASK_SUMMARY:
      return {
        ...state,
        dashboardTaskSummary: action.payload,
      };
    case GET_DASHBOARD_MEMBER_SUMMARY:
      return {
        ...state,
        dashboardMemberSummary: action.payload,
      };
    case GET_DASHBOARD_SCREENSHOT:
      return {
        ...state,
        dashboardScreenShot: action.payload,
      };
    case GET_DASHBOARD_TOP_MEMBERS:
      return {
        ...state,
        dashboardTopMembers: action.payload,
      };
    case GET_DASHBOARD_MISSED_DEAD:
      return {
        ...state,
        dashboardmissedDeadline: action.payload,
      };
    case GET_DASHBOARD_APPROACHING_DEAD:
      return {
        ...state,
        dashboardApproachingDeadline: action.payload,
      };
    case GET_REPORTS_TRACKED_HOURS:
      return {
        ...state,
        reportsTrackedHours: action.payload,
      };
    case GET_REPORTS_TRACKED_HOURS_MINUTE_WISE:
      return {
        ...state,
        reportsTrackedHoursMinuteWise: action.payload,
      };
    case GET_REPORTS_TRACKED_HOURS_IDLE_MINUTE_WISE:
      return {
        ...state,
        reportsTrackedHoursIdleMinuteWise: action.payload,
      };
    case GET_PROJECT_TASK_LIST:
      return {
        ...state,
        projectTask: action.payload,
      };
    case GET_EMPLOYEE_PROJECT_TASK_LIST:
      return {
        ...state,
        employeeProjectTasks: action.payload,
      };
    case GET_REPORTS_ACTIVITY_LEVEL:
      return {
        ...state,
        reportsActivityLevel: action.payload,
      };
    case GET_REPORTS_ATTENDANCE:
      return {
        ...state,
        reportsAttendance: action.payload,
      };
    case GET_REPORTS_ATTENDANCE_MINUTE_WISE:
      return {
        ...state,
        reportsAttendanceMinuteWise: action.payload,
      };
    case GET_REPORTS_ATTENDANCE_IDLE_MINUTE_WISE:
      return {
        ...state,
        reportsAttendanceIdleMinuteWise: action.payload,
      };
    case GET_PROJECT_TASK_BY_ID:
      return {
        ...state,
        projectTaskById: action.payload,
      };
    case GET_MONITORING_MEMBER:
      return {
        ...state,
        monitoringMember: action.payload,
      };
    case GET_MONITORING_PROJECT:
      return {
        ...state,
        monitoringProject: action.payload,
      };
    case GET_MONITORING_DAILY_ACTIVITY:
      return {
        ...state,
        monitoringDailyActivity: action.payload,
      };
    case GET_INTERNET_SPEED_LOCATION:
      return {
        ...state,
        internetSpeedLocation: action.payload,
      };
    case GET_INTERNET_SPEED_LOCATION_SUMMARY:
      return {
        ...state,
        internetSpeedLocationSummary: action.payload,
      };
    case GET_MONITORING_SCREENSHOTS:
      return {
        ...state,
        monitoringScreenshot: action.payload,
      };
    case GET_REALTIME_LIST:
      return {
        ...state,
        realTime: action.payload,
      };
    case GET_HOLIDAY__LIST:
      return {
        ...state,
        holiday: action.payload,
      };
    case GET_HOLIDAY_BY_ID:
      return {
        ...state,
        holidayById: action.payload,
      };
    case GET_LEAVE_LIST:
      return {
        ...state,
        leave: action.payload,
      };
    case GET_LEAVE_POLICY:
      return {
        ...state,
        leavePolicy: action.payload,
      };
    case GET_TIMESHEET_MEMBER:
      return {
        ...state,
        timesheetMember: action.payload,
      };
    case GET_TIMESHEET_TASK_LIST:
      return {
        ...state,
        timesheetTask: action.payload,
      };
    case GET_TIMESHEET:
      return {
        ...state,
        timesheet: action.payload,
      };
    case GET_LEAVE_BALANCE:
      return {
        ...state,
        leaveBalance: action.payload,
      };
    case GET_LEAVE_POLICY_BY_ID:
      return {
        ...state,
        leavePolicyByID: action.payload,
      };
    case GET_TIMEEDITOR_LIST:
      return {
        ...state,
        timeEditor: action.payload,
      };
    case GET_TIMESHEET_PROJECT_LIST:
      return {
        ...state,
        timesheetProject: action.payload,
      };
    case GET_REALTIME_MEMBER_LIST:
      return {
        ...state,
        realTimeMember: action.payload,
      };
    case GET_REALTIME_PROJECT_LIST:
      return {
        ...state,
        realTimePoject: action.payload,
      };
    case GET_ARCHIVED_USER:
      return {
        ...state,
        archivedUser: action.payload,
      };
    case GET_ONBOARD_USER:
      return {
        ...state,
        onBoardUser: action.payload,
      };
    case GET_ONBOARD_STATUS:
      return {
        ...state,
        onBoardStatus: action.payload,
      };
    case GET_ONBOARD_MEMBERS_LIST:
      return {
        ...state,
        onBoardMembers: action.payload,
      };
    case GET_ONBOARD_TEAMS_LIST:
      return {
        ...state,
        onBoardTeams: action.payload,
      };
    case GET_SCREENSHOT_DETAILS:
      return {
        ...state,
        screenShotDetails: action.payload,
      };
    case GET_DOMAIN_USER:
      return {
        ...state,
        domainUser: action.payload,
      };
    case GET_DOMAIN_DETAILS:
      return {
        ...state,
        domainDetails: action.payload,
      };
    case GET_IMAGE_DATA:
      return {
        ...state,
        ImageData: action.payload,
      };
    case GET_DOMAIN_USER_BY_ID:
      return {
        ...state,
        domainUserById: action.payload,
      };
    case GET_SUPERADMIN_DASHBOARD_DATA:
      return {
        ...state,
        adminDashboardData: action.payload,
      };
    case GET_SCHEDULE_REPORT_LIST:
      return {
        ...state,
        scheduleReport: action.payload,
      };
    case GET_SCHEDULE_REPORT_BYID:
      return {
        ...state,
        scheduleReportByID: action.payload,
      };
    case GET_SHARE_REPORT:
      return {
        ...state,
        shareReport: action.payload,
      };
    case GET_SHARE_REPORT_PUBLIC:
      return {
        ...state,
        shareReportPublic: action.payload,
      };
    case GET_TIMEZONE_LIST:
      return {
        ...state,
        timezone: action.payload,
      };
    case GET_TIMEZONES:
      return {
        ...state,
        timezoneList: action.payload,
      };
    case GET_WORKSPACE:
      return {
        ...state,
        workspace: action.payload,
      };
    case GET_EMPLOYEE_DOMAIN:
      return {
        ...state,
        empDomain: action.payload,
      };
    case GET_EMPLOYEE_DASHBOARD:
      return {
        ...state,
        empDashboard: action.payload,
      };
    case GET_CHAT_EMPLOYEE_LIST:
      return {
        ...state,
        chatEmployee: action.payload,
      };
    case GET_EMPLOYEE_WORKSPACE:
      return {
        ...state,
        empWorkspace: action.payload,
      };
    case GET_EMPLOYEE_TIMESHEET_MEMBER:
      return {
        ...state,
        empTimeMembers: action.payload,
      };
    case GET_EMPLOYEE_TIMESHEET_PROJECT:
      return {
        ...state,
        empTimePrject: action.payload,
      };
    case GET_EMPLOYEE_TIMESHEET_PROJECT_TASK:
      return {
        ...state,
        empTimePrjectTask: action.payload,
      };
    case GET_EMPLOYEE_TIMESHEET:
      return {
        ...state,
        empTimesheet: action.payload,
      };
    case GET_TIME_REQUEST:
      return {
        ...state,
        timeRequest: action.payload,
      };
    case GET_EMPLOYEE_PAST_ACTIVITIES:
      return {
        ...state,
        employeePastActivities: action.payload,
      };
    case GET_EMPLOYEE_APP_USAGE:
      return {
        ...state,
        employeeAppUsage: action.payload,
      };
    default:
      return state;
  }
};

export default mainReducer;
